import { createContext, useState, useContext } from "react";
import PropTypes from "prop-types";

const VehicleFilterContext = createContext(null);

export const VehicleFilterProvider = ({ children }) => {
  // ==================== DASHBOARD VEHICLE FILTERS ====================
  const [dashboardVehicle, setDashboardVehicle] = useState({
    selectedPage: 1,
    filter: "",
    sortOption: "",
    activeTab: 0,
    selectedVehicleTypeId: null,
  });

  // ==================== DASHBOARD DOCUMENTS FILTERS ====================
  const [dashboardDocuments, setDashboardDocuments] = useState({
    selectedPage: 1,
    searchInputValue: "",
    activeSearchFilter: "",
    sortOption: "",
    vehicleTypeFilter: "",
    operationFilter: "",
    documentFilter: "all",
    showExtraDocuments: false,
    selectedVehicleId: null,
    selectedVehicleType: "main",
  });

  // ==================== DASHBOARD VEHICLE SETTERS ====================
  const setDashboardVehicleSelectedPage = (page) => {
    setDashboardVehicle(prev => ({ ...prev, selectedPage: page }));
  };

  const setDashboardVehicleFilter = (filter) => {
    setDashboardVehicle(prev => ({ ...prev, filter }));
  };

  const setDashboardVehicleSortOption = (sortOption) => {
    setDashboardVehicle(prev => ({ ...prev, sortOption }));
  };

  const setDashboardVehicleActiveTab = (activeTab) => {
    setDashboardVehicle(prev => ({ ...prev, activeTab }));
  };

  const setDashboardVehicleSelectedVehicleTypeId = (selectedVehicleTypeId) => {
    setDashboardVehicle(prev => ({ ...prev, selectedVehicleTypeId }));
  };

  const clearDashboardVehicleFilters = () => {
    setDashboardVehicle({
      selectedPage: 1,
      filter: "",
      sortOption: "",
      activeTab: 0,
      selectedVehicleTypeId: null,
    });
  };

  // ==================== DASHBOARD DOCUMENTS SETTERS ====================
  const setDashboardDocumentsSelectedPage = (page) => {
    setDashboardDocuments(prev => ({ ...prev, selectedPage: page }));
  };

  const setDashboardDocumentsSearchInputValue = (value) => {
    setDashboardDocuments(prev => ({ ...prev, searchInputValue: value }));
  };

  const setDashboardDocumentsActiveSearchFilter = (filter) => {
    setDashboardDocuments(prev => ({ ...prev, activeSearchFilter: filter }));
  };

  const setDashboardDocumentsSortOption = (sortOption) => {
    setDashboardDocuments(prev => ({ ...prev, sortOption }));
  };

  const setDashboardDocumentsVehicleTypeFilter = (filter) => {
    setDashboardDocuments(prev => ({ ...prev, vehicleTypeFilter: filter }));
  };

  const setDashboardDocumentsOperationFilter = (filter) => {
    setDashboardDocuments(prev => ({ ...prev, operationFilter: filter }));
  };

  const setDashboardDocumentsDocumentFilter = (filter) => {
    setDashboardDocuments(prev => ({ ...prev, documentFilter: filter }));
  };

  const setDashboardDocumentsShowExtraDocuments = (show) => {
    setDashboardDocuments(prev => ({ ...prev, showExtraDocuments: show }));
  };

  const setDashboardDocumentsSelectedVehicleId = (vehicleId) => {
    setDashboardDocuments(prev => ({ ...prev, selectedVehicleId: vehicleId }));
  };

  const setDashboardDocumentsSelectedVehicleType = (vehicleType) => {
    setDashboardDocuments(prev => ({ ...prev, selectedVehicleType: vehicleType }));
  };

  const clearDashboardDocumentsFilters = () => {
    setDashboardDocuments({
      selectedPage: 1,
      searchInputValue: "",
      activeSearchFilter: "",
      sortOption: "",
      vehicleTypeFilter: "",
      operationFilter: "",
      documentFilter: "all",
      showExtraDocuments: false,
      selectedVehicleId: null,
      selectedVehicleType: "main",
    });
  };

  const value = {
    // Dashboard Vehicle
    dashboardVehicle,
    setDashboardVehicleSelectedPage,
    setDashboardVehicleFilter,
    setDashboardVehicleSortOption,
    setDashboardVehicleActiveTab,
    setDashboardVehicleSelectedVehicleTypeId,
    clearDashboardVehicleFilters,

    // Dashboard Documents
    dashboardDocuments,
    setDashboardDocumentsSelectedPage,
    setDashboardDocumentsSearchInputValue,
    setDashboardDocumentsActiveSearchFilter,
    setDashboardDocumentsSortOption,
    setDashboardDocumentsVehicleTypeFilter,
    setDashboardDocumentsOperationFilter,
    setDashboardDocumentsDocumentFilter,
    setDashboardDocumentsShowExtraDocuments,
    setDashboardDocumentsSelectedVehicleId,
    setDashboardDocumentsSelectedVehicleType,
    clearDashboardDocumentsFilters,
  };

  return (
    <VehicleFilterContext.Provider value={value}>
      {children}
    </VehicleFilterContext.Provider>
  );
};

export const useVehicleFilter = () => {
  const context = useContext(VehicleFilterContext);
  if (!context) {
    throw new Error("useVehicleFilter debe ser usado dentro de VehicleFilterProvider");
  }
  return context;
};

VehicleFilterProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
